import styled from 'styled-components';

export const SearchMoreWrapper = styled.div`
	height: 50px;
	margin: 0 30px 60px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
